import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/for-organizations")({
  head: () => seoHead("/for-organizations"),
  beforeLoad: () => {
    throw redirect({ to: "/lp/organizations", replace: true });
  },
});